import { QueryClient, QueryFunction } from "@tanstack/react-query";
import { api } from "./apiClient";

/**
 * Make an API request with automatic auth headers.
 * Returns Response for backwards compatibility with existing callers.
 */
export async function apiRequest(
  method: string,
  url: string,
  data?: unknown | undefined,
): Promise<Response> {
  // Use the centralized api client which handles auth
  // We need to return Response for compatibility, so we wrap it
  return api.request(method, url, data);
}

type UnauthorizedBehavior = "returnNull" | "throw";
export function getQueryFn<T>(options: {
  on401: UnauthorizedBehavior;
}): QueryFunction<T> {
  return async ({ queryKey }) => {
    try {
      return await api.get<T>(queryKey.join("/"));
    } catch (error) {
      // Handle 401 specially if configured to return null
      if (
        options.on401 === "returnNull" &&
        error instanceof Error &&
        error.message.includes("failed: 401")
      ) {
        return null as T;
      }
      throw error;
    }
  };
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
